import { ThemeProvider } from "@emotion/react";
import { QueryClientProvider } from "@tanstack/react-query";
import { Provider } from "react-redux";
import { RouterProvider } from "react-router-dom";
import { ZoomMediaProvider } from "./ZoomMediaProvider";
import { LoadingProvider } from "./context/LoadingProvider";
import { ReminderProvider } from "./context/ReminderProvider";
import { SnackbarProvider } from "./context/SnackbarProvider";
import { queryClient } from "./queries/query-client";
import { store } from "./redux/store";
import { router } from "./router/Router";
import { globallyInstallRefreshTokenInterceptor } from "./services/interceptor";
import theme from "./theme";
import { ZoomClientProvider } from "./zoom/zoom-context";
import { FcmProvider } from "./services/fcm/FcmProvider";

globallyInstallRefreshTokenInterceptor();

declare global {
  interface Window {
    webEndpoint: string | undefined;
    zmClient: any;
    mediaStream: any;
    crossOriginIsolated: boolean;
    ltClient: any;
    logClient: any;
  }
}

const App = () => {
  return (
    <Provider store={store}>
      <SnackbarProvider>
        <FcmProvider>
          <QueryClientProvider client={queryClient}>
            <LoadingProvider>
              <ZoomClientProvider>
                <ZoomMediaProvider>
                  <ThemeProvider theme={theme}>
                    {/* <AuthProvider> */}
                    <ReminderProvider>
                      {/* <RoleProvider> */}
                      <RouterProvider router={router} />
                      {/* </RoleProvider> */}
                    </ReminderProvider>
                    {/* </AuthProvider> */}
                  </ThemeProvider>
                </ZoomMediaProvider>
              </ZoomClientProvider>
            </LoadingProvider>
          </QueryClientProvider>
        </FcmProvider>
      </SnackbarProvider>
    </Provider>
  );
};

export default App;
